// Program UI Settings Types

export interface LoginFeatureCard {
  icon?: string;
  title?: string;
  description?: string;
}

export interface LoginPageStat {
  value?: string;
  label?: string;
}

export interface ProgramUISettingsDto {
  programUISettingsId: string;
  programId: string;
  
  // Tab/Browser Settings
  tabTitle?: string;
  faviconUrl?: string;
  
  // Theme Color Settings
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  
  // Logo Settings
  loginPageLogoUrl?: string;
  internalHeaderLogoUrl?: string;
  internalSidebarLogoUrl?: string;
  logoAltText?: string;
  showProgramNameWhenLogoMissing: boolean;
  increaseFallbackLogoSize: boolean;
  
  // Login Page Right Section Customization
  loginPageTitle?: string;
  loginPageSubtitle?: string;
  loginPageDescription?: string;
  
  // Login Page Feature Cards
  loginFeatureCards?: LoginFeatureCard[];
  
  // Login Page Statistics
  loginPageStats?: LoginPageStat[];
  
  // Background Customization
  loginBackgroundType?: 'gradient' | 'solid' | 'image';
  loginBackgroundValue?: string;
  loginBackgroundPatternEnabled: boolean;
  
  // Status
  isActive: boolean;
  
  // Audit Fields
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface CreateProgramUISettingsDto {
  tabTitle?: string;
  faviconUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  loginPageLogoUrl?: string;
  internalHeaderLogoUrl?: string;
  internalSidebarLogoUrl?: string;
  logoAltText?: string;
  showProgramNameWhenLogoMissing?: boolean;
  increaseFallbackLogoSize?: boolean;
  loginPageTitle?: string;
  loginPageSubtitle?: string;
  loginPageDescription?: string;
  loginFeatureCards?: LoginFeatureCard[];
  loginPageStats?: LoginPageStat[];
  loginBackgroundType?: 'gradient' | 'solid' | 'image';
  loginBackgroundValue?: string;
  loginBackgroundPatternEnabled?: boolean;
  isActive?: boolean;
}

export interface PublicProgramUISettingsDto {
  tabTitle?: string;
  faviconUrl?: string;
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  loginPageLogoUrl?: string;
  internalHeaderLogoUrl?: string;
  internalSidebarLogoUrl?: string;
  logoAltText?: string;
  showProgramNameWhenLogoMissing?: boolean;
  increaseFallbackLogoSize?: boolean;
  loginPageTitle?: string;
  loginPageSubtitle?: string;
  loginPageDescription?: string;
  loginFeatureCards?: LoginFeatureCard[];
  loginPageStats?: LoginPageStat[];
  loginBackgroundType?: 'gradient' | 'solid' | 'image';
  loginBackgroundValue?: string;
  loginBackgroundPatternEnabled: boolean;
  programName?: string;
}

// Default theme settings (used when no program-specific settings exist)
export const DEFAULT_UI_SETTINGS: Partial<PublicProgramUISettingsDto> = {
  primaryColor: 'primary',
  secondaryColor: 'info',
  accentColor: 'info',
  loginBackgroundType: 'gradient',
  loginBackgroundPatternEnabled: true,
  loginPageTitle: 'EPPREM',
  loginPageSubtitle: 'Enhanced Patient Support Program',
  loginPageDescription: 'Empowering healthcare teams to deliver personalized patient care with streamlined program management and real-time insights.',
  showProgramNameWhenLogoMissing: true,
  increaseFallbackLogoSize: true,
  loginFeatureCards: [
    { icon: 'support', title: 'Comprehensive Support', description: 'End-to-end patient program management' },
    { icon: 'secure', title: 'HIPAA Compliant', description: 'Enterprise-grade security & privacy' },
    { icon: 'patients', title: 'Patient-Centric', description: 'Designed with patients in mind' }
  ],
  loginPageStats: [
    { value: '10K+', label: 'Patients Served' },
    { value: '500+', label: 'Healthcare Providers' },
    { value: '99.9%', label: 'Uptime' }
  ]
};
